import {PaymentType} from 'mobile/typescript/paymentTypes';

type PaymentDataMapType = {
    method: string;
    save_card: 0 | 1;
    token?: string;
    session_id?: string;
    is_iframe: number;
    cc_payment_token: string;
    cc_saved_card?: string;
    cc_customer_email: string;
    cc_customer_name: string;
    cc_saved_cid: string;
    cc_type: string;
    cc_number: string;
    cc_exp_month?: string;
    cc_exp_year?: string;
    cc_cid?: string;
    payment_method_id?: string;
    payment_id?: string;
};

/**
 * Defines if apple pay is available
 * @returns {boolean} true if apple pay is available
 */
export const isApplePayAvailable = (): boolean =>
    Boolean(window.ApplePaySession && window.ApplePaySession.canMakePayments());

/**
 * Convert data from active payment from store to structure appropriate for backend
 * @param {PaymentType} paymentInfo - active payment from store
 * @returns {PaymentDataMapType} true if apple pay is available
 */
export const getConvertedPaymentObject = (paymentInfo: PaymentType): PaymentDataMapType => ({
    cc_cid: paymentInfo.cvv,
    cc_customer_email: paymentInfo.customerEmail || '',
    cc_customer_name: paymentInfo.customerName || '',
    cc_exp_month: paymentInfo.month,
    cc_exp_year: paymentInfo.year,
    cc_number: (paymentInfo.cardNumber || '').replace(/-/g, ''),
    cc_payment_token: paymentInfo.paymentToken || '',
    cc_saved_card: paymentInfo.paymentMethodToken,
    cc_saved_cid: paymentInfo.saveCid || '',
    cc_type: paymentInfo.type2 || '', // TODO: Mary check if it works in some cases
    is_iframe: 1,
    method: paymentInfo.code,
    payment_id: paymentInfo.payment_id,
    payment_method_id: paymentInfo.paymentId,
    save_card: paymentInfo.saveCard ? 1 : 0,
    session_id: paymentInfo.sessionId,
    token: paymentInfo.paymentMethodToken,
});
